<div id="more-filter">
  <h2 class="m-b-5" mat-dialog-title>Filtros</h2>
  <div mat-dialog-content>
      <!-- Replace the following depending on the specific selection -->
      <app-emp-filter *ngIf="sharedService.selectedSelectionTabId == 1"></app-emp-filter>
      <app-leave-filter *ngIf="sharedService.selectedSelectionTabId == 2"></app-leave-filter>
      <app-task-filter *ngIf="sharedService.selectedSelectionTabId == 5"></app-task-filter>
      <app-actuation-filter *ngIf="sharedService.selectedSelectionTabId == 3"></app-actuation-filter>
  </div>
  
  <div class="text-a-r  m-t-10 m-b-10">
    <button mat-raised-button color="accent" (click)="searchList()" class="m-r-15">Consultar</button>
    <button mat-raised-button (click)="clearFilter()" color="primary"  class="m-r-15">Quitar</button>
    <button mat-raised-button (click)="cancel()" color="warn">Cancelar</button>
  </div>
</div>